import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';
import StoryTile from '../StoryTile';
import styles from './TeaserGrid.module.styl';

const backupImage = 'arc-anglerfish-arc2-prod-bostonglobe/public/NK2C2JTRVII6RCTVNGPDN5O6DA.jpg';

const TeaserGrid = ({ stories, currentId }) => (
  <div className={styles.teaserGrid}>
    <h3 className={classNames(styles.title, 'bentoncond-n4')}>
      <span>
        Next Up In This Series
      </span>
    </h3>
    <ul className={styles.storyGrid}>
      {stories.map((story) => {
        if (story.storyId === currentId) {
          return null;
        }

        const imageUrl = get({}, 'image', '').trim()
          || get(story, 'promo_items.basic.url', '').trim()
          || backupImage;

        return (
          <StoryTile
            key={story.storyId}
            aspectRatio={16 / 9}
            headline={story.headlines.basic}
            href={story.path}
            image={imageUrl}
            imgAlt={story.headlines.basic}
            isDisplayed
          />
        );
      })}
    </ul>
  </div>
);

TeaserGrid.propTypes = {
  currentId: PropTypes.string.isRequired,
  stories: PropTypes.arrayOf(PropTypes.shape({
    storyId: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  })).isRequired,
};

export default TeaserGrid;
